module.exports = [
  /*
  * Common
  */
  "getRequestId", 
  "isInstalledApp",
  /*
  * DeviceInfo
  */
  "getNetworkType", 
  "getVersion",
  /*
  * UserInfos
  */
  "getUserInfo", 
  "login", 
  "updateAccount", 
  "logout",
  "thirdLogin",
  /*
  * GeoInfos
  */ 
  "getCityId", 
  "getLocation", 
  "getCity",
  /*
  * Common business
  */
  "setPullDown", 
  "stopPullDown", 
  "openScheme", 
  "jumpToScheme", 
  "closeWindow", 
  "getContactList", 
  "sendSMS", 
  "bindPhone",
  "ajax", 
  "setSpotlight",
  "getHealthData",
  "pickCity",
  "analyticsTag",
  /*
  * Storage
  */
  "store", 
  "retrieve",
  /*
  *  Picture
  */
  "downloadImage", 
  "chooseImage", 
  "previewImage",
  "uploadImage",
  /*
  * Audio
  */
  "playVoice",
  /*
  * Share
  */
  "share",
  /*
  * Broadcast
  */
  "publish", 
  "subscribe", 
  "unsubscribe", 

  /*
  * System widget
  */
  "alert", 
  "prompt", 
  "confirm", 
  "actionSheet", 
  /*
  * System UI
  */
  "setTitle", 
  "setBackgroundColor", 
  "setNavigationBarHidden", 
  "setScrollEnabled",
  "setLLButton", 
  "setLRButton", 
  "setRLButton", 
  "setRRButton", 
  "setBouncesEnabled",
  "setStatusBarStyle",
  /*
    Other
   */
  "setBarrageEnabled",
  /*
  * Private
  */
  "getCX",
  "pay"
];


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/apis.js
// module id = 199
// module chunks = 0